import { computed, type MaybeRefOrGetter, toValue } from "vue";

export const useCssClass = (
  customClass: MaybeRefOrGetter<string | Record<string, boolean> | string[] | undefined>,
  defaultClass = "",
) => {
  const cssClass = computed(() => {
    const value = toValue(customClass);

    if (!value) {
      return defaultClass;
    }

    if (Array.isArray(value)) {
      return value.length ? value : defaultClass;
    }

    if (typeof value === "object") {
      const hasPositiveValue = Object.values(value).some(Boolean);
      return hasPositiveValue ? value : defaultClass;
    }

    return defaultClass;
  });

  return {
    cssClass,
  };
};
